<template>
  <div>
    <h3 v-if="mw && mw.title" class="mb-4">{{ mw.title }}</h3>
    <template v-if="mw.content">
      <p v-for="(t, i) in mw.content" :key="i" class="mb-2">{{ t }}</p>
    </template>
    <a-form-model2
      v-model="data"
      class="mt-4"
      :model="model"
      :modelForm="modelForm"
      :values="data"
      :errors="errors"
      :config="{ dense: true, hideDetails: 'true', readonly: this.id }"
      @validate="
        validate($event);
        trigger($event);
      "
    />
    <s-tree-block :value="wizard" v-if="getAccess('contract.wizard.debug')" />

    <portal to="v-wizard-action" v-if="loaded">
      <v-btn v-if="!readonly" @click="onUndo" class="mr-2">Назад</v-btn>
      <v-btn v-if="!estimate.id" @click="submit">Создать предложение</v-btn>
      <v-btn v-if="!estimate.id && !estimate.skip" @click="onSkip">Пропустить</v-btn>
      <v-btn v-if="estimate.id" @click="showDocument = true">Открыть</v-btn>
      <v-btn v-if="estimate.id || estimate.skip" @click="onNext">Далее</v-btn>
    </portal>
    <v-dialog v-model="showDocument" persistent scrollable @keydown.esc="showDocument = false">
      <v-btn style="position: absolute; right: 20px; top: 20px; z-index: 100" fab dark small color="blue-grey" title="Закрыть окно" @click="showDocument = false">
        <v-icon dark> mdi-close </v-icon>
      </v-btn>
      <v-card style="position: absolute; top: 10px; left: 10px; right: 10px; bottom: 10px; width: auto; margin: auto" height="auto">
        <ViewItem v-if="showDocument" :idShow="id" @close="itemShowClose($event)" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getForm, submitForm, removeEl, genModel, getAccess } from "@/components/mixings";
import validators from "@/components/libs/validators";

export default {
  components: {
    ViewItem: () => import("@/views/documents/views/estimateView"),
  },
  mixins: [getForm, submitForm, removeEl, genModel, getAccess],
  props: {
    wizard: {
      type: Object,
      default: () => {},
    },
    mw: {
      type: Object,
      default: () => {},
    },
    defaults: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showDocument: false,
      m: this.$store.getters["config/get"].models.documentEstimate,
      model1: [],
      isNew: 0,
      model: [],
      id: null,
      loaded: false,
      type: 4,
      estimate: {},
    };
  },
  computed: {
    readonly() {
      return !!this.wizard?.contract?.template_id;
    },
    api() {
      return this.m.api;
    },
    config() {
      const c = this.mw?.config || {};
      const services = (this.wizard?.services?.services || []).map(s => s.value);

      c.fieldsReplace = {
        type: { name: "type", default: 4, _type: "join" },
        client_id: { name: "client_id", type: "selectapi", dir: "", api: "mechti/clients/select", default: this.wizard.client.id, validator: ["req"], _type: "join" },
        object_id: { name: "object_id", type: "selectapi", dir: "", api: "mechti/objects/select", default: this.wizard.object.id, validator: ["req"], _type: "join" },
        template_name: { name: "template_name", default: "promo_test2", _type: "join" },
        object_square: { name: "object_square", default: this.wizard?.object?.data?.ap_area, _type: "join" },
        object_class: { name: "object_class", default: "business", _type: "join" },
        "data.services": { name: "data.services", default: services, validator: ["req"], _type: "join", hiddenCreate: false },
        "data.total_price": { name: "data.total_price", validator: ["req"], _type: "join", hiddenCreate: false },
        status: { name: "status", title: "Статус", default: 2, hidden: true },
      };
      return c;
      return this.mw?.estimate?.config || {}; //.wizardContract;
    },
  },
  created() {
    this.init();
  },
  watch: {
    id(v) {
      this.estimate.id = v;
    },
  },
  methods: {
    waitFor(conditionFn) {
      return new Promise(resolve => {
        const check = () => {
          if (conditionFn()) return resolve();

          // ждать и снова проверять
          setTimeout(check, 30);
        };
        check();
      });
    },
    waitForEvent(eventName, payload) {
      return new Promise(resolve => {
        this.$emit(eventName, payload, resolve);
      });
    },
    async init(w = this.wizard.estimate || {}) {
      this.loaded = !true;
      console.log("init", w);

      this.id = w?.id || null;
      this.updateData(this.id);
    },

    onSelect(v) {
      console.log("select", v);
      this.updateData(v.value);
    },
    formatData(data) {
      let res = {};
      this.model.forEach(m => {});
    },
    afterFetchData(r) {
      console.log("afterFetchData", r);

      this.estimate = Object.assign({}, this.wizard.estimate);
      if (!r && this.estimate.id) this.estimate = {};
      this.id = this.estimate.id;
      this.calcModel();
      if (!this.data?.id) this.trigger("object_class");

      this.loaded = true;
    },
    calcModel(t) {
      let config = this.config;
      //if (t) config = JSON.parse(JSON.stringify(this.m?.config?.[t] || this.config));
      console.log("run calc", config);
      let model = this.calcModelConfig(config, this.m);

      this.fillFormFromModel(model);
      this.model = model;
      return model;
    },
    submit1() {
      console.log("after save ", this.data);
      this.onNext();
    },
    async onSkip() {
      this.estimate = { skip: true };
      const result = await this.waitForEvent("save", this.estimate);
      this.$emit("next");
    },
    async afterSave(data, status) {
      this.id = data.id;
      this.estimate = Object.assign({}, { id: this.data.id, data: this.getDataForModel(this.model, this.data) });
      console.log("after save ", data);
      const result = await this.waitForEvent("save", this.estimate);
      //await this.init({ id: data.id });
      this.isChanged = false;
    },

    async onUndo() {
      await this.waitForEvent("save", {});
      this.$emit("next", -1);
    },
    async onNext() {
      this.$emit("next");
      console.log("on next", this.wizard.estimate);
    },
    async trigger(e) {
      let field = e;
      let data = this.data;
      // console.log("trigger", e);
      await this.waitFor(() => this.$root.dirs.service.length > 0);
      const calcPrice = data => {
        const items = this.m.items;
        let price = 0;

        const { object_class, object_square } = data;
        const services = this.$root.dirs.service;

        data.data.services.forEach(s => {
          const r = items.find(el => el.value === s);
          let p = r?.price || 0;
          if (r?.service_id) {
            const s = services.find(el => el.value == r.service_id) || {};
            p = (s?.["price_" + object_class] || 0) * (s?.data?.client_ratio || 1);
          }
          price += p * (object_square || 0);
        });
        return price;
      };

      if (["data.services", "object_class", "object_square"].includes(field)) {
        data.data.total_price = calcPrice(data);
      }
    },
  },
};
</script>
